import type { Role } from '@/lib/auth-context';

export interface AdminUserManagerLink {
  manager: { id: string; fullName: string; email?: string };
}

export interface AdminUserSummary {
  id: string;
  email: string;
  fullName: string;
  role: Role;
  employeeCode: string | null;
  isActive: boolean;
  deletedAt: string | null;
  /** Lista N:M de managers asignados al empleado. */
  managers: AdminUserManagerLink[];
  /** Provincia/región del empleado (ej. 'ES-AN-SE'). */
  region: string;
  /** Municipio del empleado; '' = sin municipio asignado. */
  municipality: string;
  /** Color de fondo del avatar (hex de paleta) o null = por defecto. */
  profileColor: string | null;
  /** Marca de cache-busting de la foto; null = sin foto. */
  avatarUpdatedAt: string | null;
}

export interface AdminUserDetail extends AdminUserSummary {
  passwordChangeRequired: boolean;
  scheduleAssignments?: {
    id: string;
    validFrom: string;
    validTo: string | null;
    schedule: { id: string; name: string };
  }[];
}

export interface AdminScheduleSummary {
  id: string;
  name: string;
  description?: string | null;
}

export interface AdminRegionSummary {
  /** Código interno (ej. 'ES-AN-SE'). */
  code: string;
  /** Nombre legible (ej. 'Sevilla'). */
  name: string;
  /** Comunidad Autónoma (para agrupar en `<optgroup>`). */
  ca: string;
}

export const ROLE_OPTIONS: { value: Role; label: string }[] = [
  { value: 'EMPLOYEE', label: 'Empleado' },
  { value: 'MANAGER', label: 'Manager' },
  { value: 'HR_ADMIN', label: 'RRHH' },
  { value: 'SUPER_ADMIN', label: 'Admin' },
];

export function roleLabel(role: Role): string {
  return ROLE_OPTIONS.find((r) => r.value === role)?.label ?? role;
}
